import { Text } from "@chakra-ui/react";
import * as React from "react";

import { brand } from "../lib/brand";
import { Button } from "./button";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "./dialog";

interface PauseAgentDialogProps {
  open: boolean;
  campaignName: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function PauseAgentDialog({
  campaignName,
  onCancel,
  onConfirm,
  open,
}: PauseAgentDialogProps) {
  return (
    <DialogRoot
      open={open}
      onOpenChange={(details) => {
        if (!details.open) onCancel();
      }}
    >
      <DialogContent>
        <DialogCloseTrigger />
        <DialogHeader>
          <DialogTitle>Turn off {brand.productName}?</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Text color="fg.muted" fontFamily="inter" fontSize="sm">
            {brand.productName} will stop adjusting bids and budget for &ldquo;
            {campaignName ?? "this campaign"}&rdquo; and restore the
            campaign&rsquo;s original settings. You can turn it back on any
            time.
          </Text>
        </DialogBody>
        <DialogFooter>
          <Button onClick={onCancel} variant="surface">
            Cancel
          </Button>
          <Button onClick={onConfirm} variant="solid">
            Turn off {brand.productName}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
}
